module.exports = __webpack_public_path__ + "img/UP380C&BT2.pic.7aa1440f.png";